module.exports = __webpack_public_path__ + "3ddbaa1365620f72493eb8674cf13780.ttf";


//////////////////
// WEBPACK FOOTER
// ./static/fonts/support-widget.ttf
// module id = 51Me
// module chunks = 0